"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapContract = void 0;
const ethers_1 = require("ethers");
const wrapContract = (contract, relayer) => {
    const abi = contract.interface.fragments;
    const funcs = abi.reduce((memo, frag) => {
        if (frag.type === "function") {
            const funcFrag = frag;
            if (["payable", "nonpayable"].includes(funcFrag.stateMutability)) {
                const newFunc = async (...args) => {
                    return relayer.transmit(contract, funcFrag.name, ...args);
                };
                memo[funcFrag.name] = newFunc;
            }
        }
        return memo;
    }, {});
    // The reason we return a new object here rather than a proxy
    // or modifying the original contract is that
    // Contract sets its properties as ReadOnly and so you cannot modify them
    // or else it throws a TypeError
    const newContract = {
        ...contract,
        ...funcs,
    };
    Object.setPrototypeOf(newContract, ethers_1.Contract.prototype);
    return newContract;
};
exports.wrapContract = wrapContract;
